import React, { useRef, useState, useEffect } from "react";
import {
  DownOutlined,
  FilePdfOutlined,
  LeftOutlined,
  RightOutlined,
  FileExcelFilled,
  UpOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { ReactComponent as Fileupload } from "../../assets/fileupload.svg";

// import { ReactComponent as UploadIcon } from "../../assets"
import { ReactComponent as Send1 } from "../../assets/send.svg";
import { ReactComponent as Imag1 } from "../../assets/img.svg";
import { ReactComponent as PDFimge } from "../../assets/pdf.svg";

import styled from "styled-components";
import { useLocation } from "react-router-dom";

import { ReactComponent as Attach } from "../../assets/Filter.svg";

import { useParams } from "react-router-dom";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import moment1 from "moment-timezone";
import {
  Avatar,
  Button,
  Card,
  Carousel,
  Col,
  Input,
  message,
  Modal,
  Row,
  Select,
  Typography,
  Spin,
  Upload,
} from "antd";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { get, startCase } from "lodash";
import COLORS from "common/Colors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import EditorConvertToHTML from "atoms/EditorConvertToHTML";
import { CALL_API } from "common/API";
import { getUserInfo, getUserList, getLocations } from "redux/selectors";
import { connect } from "react-redux";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import download from "downloadjs";

const { Title, Text } = Typography;
dayjs.extend(customParseFormat);
const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
const Styleddiv = styled.div`
  .abc {
    margin-top: -10px;
  }
  .ant-card-body {
    padding: 0px 14px 14px 14px;
    border-radius: 10px;
  }
  .ant-card-head {
    padding: 0px;
    border: none;
  }
  .ant-card-head-title {
    padding: 0px;
  }
  .ant-card {
    border-radius: 10px;
  }
  .button-container {
    display: flex;
    gap: 20px;
    // justify-content: flex-end; /* Align buttons to the left and right */
    // padding: 10px;
    // margin-top:-20px;
  }
  .yy {
    border-radius: 8px;
    margin-right: -20px;
  }

  .send-button {
    font-size: 14px;
    bottom: 18px; /* Adjust this value to place it at the desired position */
    right: 20px; /* Adjust this value to place it at the desired position */
  }
  .sendstylee {
    margin-top: -5px;
    margin-left: -18px;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .carousel-buttons {
    display: flex;
    gap: 8px;
  }
  .breadcrumb {
    display: flex;
    align-items: center;
  }
  .disciplinary-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .breadcrumb svg {
    width: 10px;
    height: 10px;
    color: #636980;
    margin-bottom: 10px;
  }
  .view-detail {
    font-weight: 400;
    font-size: 16px;
  }

  .emp-name {
    font-weight: 500;
    font-size: 16px;
    color: #636980;
  }
  .emp-id {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-bottom: 13px;
  }
  .name-edit-delete {
    display: flex;
    justify-content: space-between;
  }
  .name-edit-delete div {
    display: flex;
    align-items: center;
  }
  .trash-edit-move {
    margin-right: 70px;
    gap: 10px;
  }
  .two-container {
    display: flex;
    gap: 20px;
  }

  .employee-div {
    display: flex;
    flex-wrap: wrap;
  }
  .line-emp-id {
    color: #e2e2e8;
    margin-bottom: 15px;
  }
  .emp-name-id {
    gap: 10px;
  }
  .id-upload {
    display: flex;
    justify-content: space-between;
    // gap: 50px;
  }
  .employee-title {
    width: 30%;
    font-weight: 500;
    font-size: 14px;
    color: #636980;
    text-align: left;
  }
  .employee-total {
    width: 100%;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .timeline-total {
    width: 100%;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .employee-id {
    font-weight: 500;
    font-size: 16px;
  }
  .attach-text {
    color: #2d53da;
    border: none;
  }

  .item-value {
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
  }
  .add-comments {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
  }
  .custom-select .ant-select-selector {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    // border: none;
    border: 1px solid #2d53da;
  }
  .custom-select .ant-select-placeholder {
    color: #2d53da;
  }
  .comments-input {
    border-radius: 34pc;
  }
  .actions-timeline {
    font-weight: 500;
    font-size: 16px;
  }
  .timeline-name {
    font-weight: 400;
    font-size: 14px;
  }
  .timeline-action {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .verbal-warning,
  .first-warning,
  .second-warning {
    color: #119de5;
  }
  .send-button {
    margin-top: 20px; /* Adjust as needed */
  }

  .third-final-warning,
  .show-cause {
    color: #f28916;
  }
  .exoneration {
    color: #22ad22;
  }

  .suspend {
    color: #8e2a5e;
  }

  .demotion {
    color: #8e2a5e;
  }
  .clearance {
    color: #22ad22;
  }

  .timeline-date-time {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .scrollable-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 412px;
    overflow-y: auto;
  }
  // .timeline-item {
  //   word-wrap: break-word;
  // }
  .face-content {
    display: flex;
    gap: 10px;
  }
  .face-content1 {
    padding-bottom: 10px;
    display: flex;
    gap: 10px;
  }
  .timeline-date-time1 {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .for-commented {
    text-decoration: underline;
    color: #2d53da;
    cursor: pointer;
    margin-left: 120px;
   white-space: nowrap;
    
  }
  .for-commented1 {
    color: #636980;
    padding: 2.5px;
    padding-top: 6px;
    line-height: 0.5;
    width: 210px;

    border-radius: 8px;
    background-color: #f8d7da;
    display: flex;
    flex-direction: column;
    text-align: right;
    align-items: flex-end;
    margin-top: -48px;
    margin-left: 218px;
    font-size: 12px;
  }
  .datetext {
    color: red;
    font-size: 11px;
  }
  .comment-para {
    ont-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .comment-para {
    ont-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .textstyle {
    color: black;
    font-size: 16px;
    font-weight: 500;
  }
  .Mos {
    display: flex;
    justify-content: space-between;
  }
  .editor-label {
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    margin-bottom: 10px;
  }

  /* Attach Button */
  .attach-button {
    background-color: transparent;
    border: none;
    color: #007bff;
    font-size: 14px;
    cursor: pointer;
  }

  .attach-button:hover {
    text-decoration: underline;
  }
  .file_list {
    background: #fff;
    padding: 5px;
  }
  .file_bg {
    background: #daebf7;
  }
  .fileremove {
    color: #2d53da;
  }
  .slick-prev,
  .slick-next {
    font-size: 24px !important;
    color: #333 !important;
    z-index: 100;
  }

  .slick-prev {
    left: -40px !important;
  }

  .slick-next {
    right: -40px !important;
  }

  .slick-prev:hover,
  .slick-next:hover {
    color: #1890ff !important;
  }

  @media (max-width: 768px) {
    .two-container {
      display: block;
    }
    .employee-total {
      margin-bottom: 10px;
      width: 100%;
    }
    .for-commented {
      margin-left: 50px;
    }
  }
  .upload-style {
    width: 150px;
    height: 37px;
    border-radius: 5px;
    background: none;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
    border: none;
  }
`;

const StyledModal = styled(Modal)`
  .abc {
    margin-top: -50px;
  }
  .upload-style {
    width: 190px;
    height: 37px;
    border-radius: 5px;
    background: none;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
    border-radius: none;
  }
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
`;

const StyledAvatar = styled(Avatar)`
  margin-top: 5px;
  // margin-right: 0.5rem;
  line-height: 40px;
  width: 40px;
  height: 40px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
`;

const StyledSpinWrapper = styled.div`
  position: relative;
  display: inline-block;

  .spin-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .send-icon {
    opacity: ${(props) => (props.loading ? 0.5 : 1)};
    pointer-events: ${(props) => (props.loading ? "none" : "auto")};
  }
`;
const actionTimeline = [
  {
    key: "1",
    name: "Elsa Joseph",
    action: "created the ticket",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "2",
    name: "Elsa Joseph",
    action: "Moved to Verbal Warning",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "3",
    name: "Elsa Joseph",
    action: "Moved to First Warning",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "4",
    name: "Elsa Joseph",
    action: "Commented",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "5",
    name: "Elsa Joseph",
    action: "Moved to Second Warning",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "6",
    name: "Elsa Joseph",
    action: "Moved to Third & Final Warning",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
  {
    key: "7",
    name: "Elsa Joseph",
    action: "Moved to Show Cause",
    date: "04th Mar 2024",
    time: "10.20 AM",
  },
];

function ViewDisciplinary({ userInfo, userList, locationList }) {
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName1, setSelectedFileName1] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [isCommentVisible, setIsCommentVisible] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [showLoader, toggleLoader] = useState(false);
  const [details, setDetails] = useState({});
  const { disciplinaryId } = useParams(); // To get the disciplinaryId from the URL
  const location = useLocation(); // To get the state (record) passed from the previous page
  const handleOpenModal = (file) => {
    setSelectedFileUrl(file?.fileUrl);
    setSelectedFileName1(file?.fileName);
    if (file?.fileName?.endsWith(".xlsx") || file?.fileName?.endsWith(".csv")) {
      // download(url);
      const link = document.createElement("a");
      link.href = file?.fileUrl;
      link.download = file?.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      setIsModalVisible(true);
    }
  };
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedFileUrl(null);
    setSelectedFileName1("");
  };
  // Access the record passed via state
  const record = location.state?.record;

  const [fileList, setFileList] = useState([]);

  const handleCommentVisibility = (index) => {
    setIsCommentVisible((prevIndex) => (prevIndex === index ? null : index));
  };
  const [appealDetails, setAppealDetails] = useState("");
  const handleDeleteOpen = () => {
    setIsDeleteOpen(true);
  };
  const handleDeleteCancel = () => {
    setIsDeleteOpen(false);
  };
  const handleDeleteConfirm = () => {
    setIsDeleteOpen(false);
    setIsDeletedModalOpen(true);
    setTimeout(() => {
      setIsDeletedModalOpen(false);
    }, 2000);
  };

  const handleUpload = ({ file, onSuccess }) => {
    if (fileList?.length >= 7) {
      console.warn("Maximum 3 files can be uploaded.");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      onSuccess();
      setFileList([
        ...fileList,
        {
          uid: file.uid,
          base64Data: base64Data,
          contentType: file.type,
          fileName: file.name,
        },
      ]);
    };

    reader.onerror = (error) => {
      console.error("File read error:", error);
    };
  };

  const beforeUpload = (file) => {
    const isUnderSizeLimit = file.size / 1024 / 1024 < 25;

    const isNotVideo = !file.type.startsWith("video/");

    if (!isNotVideo) {
      message.error("Video files are not allowed");
      return Upload.LIST_IGNORE;
    }

    if (!isUnderSizeLimit) {
      message.error("File size must be less than 25MB");
      return Upload.LIST_IGNORE;
    }
    if (fileList?.length >= 7) {
      return false;
    }
    return true;
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getFileName = (url) => {
    if (!url) return "Attachment"; // Handle undefined/null cases

    let fileName = url.split("/").pop(); // Extract filename from URL

    // Remove 'new-' prefix (if present) and any leading digits followed by '-'
    fileName = fileName.replace(/^(new-)?\d*-?/, "");

    return fileName;
  };
  const openModal = (file) => {
    const fileName = file?.fileName?.toLowerCase();
    const fileUrl = file?.fileUrl;

    if (fileName?.endsWith(".xlsx") || fileName?.endsWith(".csv")) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file?.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      setSelectedFile(fileUrl);
      setSelectedFileName(file?.fileName);
      setIsModalOpen(true);
    }
  };

  const [editorKey, setEditorKey] = useState(0);
  const [uploadKey, setUploadKey] = useState(0);
  const EmployeeId = [
    {
      title: "Category",
      value: details?.category || "-",
      key: 1,
    },
    {
      title: "Action",
      value: (
        <span
          style={{
            color:
              details?.actions?.toLowerCase().includes("first") ||
                details?.actions?.toLowerCase().includes("second") ||
                details?.actions?.toLowerCase().includes("verbal")
                ? "#119DE5"
                : details?.actions?.toLowerCase().includes("third") ||
                  details?.actions?.toLowerCase().includes("Show Cause")
                  ? "#F28916"
                  : details?.actions?.toLowerCase().includes("suspend") ||
                    details?.actions?.toLowerCase().includes("demotion")
                    ? "#8E2A5E"
                    : details?.actions?.toLowerCase().includes("exoneration") ||
                      details?.actions?.toLowerCase().includes("clearance")
                      ? "#22AD22"
                      : details?.actions?.toLowerCase().includes("Termination")
                        ? "#D90325"
                        : "black",
          }}
        >
          {details?.actions || "-"}
        </span>
      ),
      key: 2,
    },

    {
      title: "Date of Incident",
      value: moment(details?.dateofincident, "YYYY-MM-DD")?.format(
        "Do MMMM YYYY"
      ),

      key: 3,
    },
    {
      title: "Number of Appeal",
      value: details?.noofappeal || "-",
      key: 4,
    },
    {
      title: "Description",
      value: details?.description || "-",
      key: 5,
    },
    {
      title: "Attachment",
      value:
        Array.isArray(details?.evidence) && details.evidence.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {details.evidence.map((fileUrl, index) => {
              // Determine file type based on extension
              const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fileUrl?.fileName);
              const isPdf = /\.pdf$/i.test(fileUrl?.fileName);
              const isExcel = /\.(xls|xlsx|csv)$/i.test(fileUrl?.fileName);

              // Set icon component based on file type
              const filePrefix = isImage ? (
                <Imag1 />
              ) : isPdf ? (
                <PDFimge />
              ) : isExcel ? (
                <FileExcelFilled style={{ color: "green", fontSize: "20px" }} />
              ) : (
                ""
              );

              return (
                <button
                  key={index}
                  style={{
                    boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
                    padding: "5px 8px",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    cursor: "pointer",
                    width: "220px",
                    height: "auto",
                    textAlign: "left",
                    display: "inline-block",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                  onClick={() => openModal(fileUrl)}
                >
                  {filePrefix}&nbsp;&nbsp;{fileUrl?.fileName}
                </button>
              );
            })}
          </div>
        ) : (
          "-"
        ),
      key: 6,
    },
  ];
  const getPlainText = (html) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    return tempElement.innerText || tempElement.textContent;
  };
  { console.log(details?.appeals?.length < details?.noofappeal, "details?.appeals?.length < details?.noofappeal") }

  const AppealAction = async () => {
    setLoading(true);
    try {
      const plainText = getPlainText(appealDetails);

      const { message } = await CALL_API(`disciplinary`, "post", {
        disciplinaryId: details?.disciplinaryId,
        appealText: plainText,
        createdBy: userInfo?.name,
        createdAt: new Date(), // Send in UTC format
        attachments: fileList,
      });

      if (message === "Update Successful") {
        const createdAtFormatted = moment1(new Date())
          .tz("Asia/Hong_Kong")
          ?.format("Do MMM, YYYY; hh:mm A"); // Store formatted date

        const newAppeal = {
          disciplinaryId: details?.disciplinaryId,
          appealText: plainText,
          appealFiles: fileList,
          createdAt: new Date().toISOString(), // Store UTC format for consistency
          createdAtFormatted, // Store formatted time
        };

        // setDetails((prevDetails) => ({
        //   ...prevDetails,
        //   appeals: [...prevDetails.appeals, newAppeal],
        // }));

        setAppealDetails("");
        setEditorKey((prevKey) => prevKey + 1);
        setFileList([]);
        setUploadKey((prevKey) => prevKey + 1);
        getDisData();
      }
    } catch (error) {
      console.error("Error while submitting appeal:", error);
      message.error("Failed to submit appeal. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const ContractForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [12, 12, 12, 12, 12, [, 4]],
        fields: [
          // Row 1
          [
            {
              id: 1,
              label: (
                <div className="editor-label">
                  <div>Appeal (3/3 left)</div>
                  <ButtonFilled className="m-0 send-button" htmlType="submit">
                    Send
                  </ButtonFilled>
                  <div>
                    <Upload {...props}>
                      <Button icon={<Attach />} className="attach-button">
                        Attach File
                      </Button>
                    </Upload>
                  </div>
                </div>
              ),
              type: "editor",
              name: "appeal",
              Placeholder: "Contract title",
              value: "",
            },
          ],
        ],
      },
    ],
  };

  const handleRemove = (uid) => {
    setFileList(fileList.filter((item) => item.uid !== uid));
  };

  const chunkArray = (array, size) => {
    return array?.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(array.slice(i, i + size));
      return acc;
    }, []);

    // Check if the last chunk has fewer items than the specified size
  };
  const carouselRef = useRef();
  const appealChunks = chunkArray(details?.appeals, 2);

  const getDisData = async () => {
    try {
      toggleLoader(true); // Show loader while fetching data
      const { data, code } = await CALL_API(`disciplinary/${id}`, "get", {});
      if (code === "SUCCESS") {
        setDetails(data[0]);
      } else {
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      toggleLoader(false); // Hide loader after API call
    }
  };
  useEffect(() => {
    getDisData(); // Call the correct function
  }, [id]);
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo?.userid
  );

  const createdUser = (userId) => {
    return userList?.find((user) => user?.userid === userId);
  };

  return (
    <>
      <Styleddiv>
        <div>
          <div className="breadcrumb">
            <p
              className="disciplinary-text"
              onClick={() => {
                history.goBack();
              }}
            >
              Disciplinary
            </p>
            &nbsp;
            <RightOutlined /> &nbsp;
            <p className="view-detail">View Detail</p>
          </div>
          <div className="two-container">
            <div className="employee-total">
              <div className="id-upload">
                <div className="employee-id">
                  <span className="employee-title">Disciplinary ID: </span>
                  {details?.disciplinaryId}
                </div>
              </div>
              <br />
              <div>
                {EmployeeId?.map((item) => (
                  <div
                    key={item.key}
                    className={
                      item.title === "Attachment"
                        ? "attachment-div"
                        : "employee-div"
                    }
                  >
                    <p className="employee-title">{item.title}</p>
                    <p
                      className="item-value"
                      style={
                        item.value === "Termination" ? { color: "#D90325" } : {}
                      }
                    >
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="timeline-total">
              <div className="actions-timeline">Actions' Timeline</div>
              <br />
              <div className="scrollable-container">
                <div className="face-content1">
                  <div>
                    {!createdUser(record?.createdByUserId)?.profileurl ||
                      createdUser(record?.createdByUserId)?.profileurl.trim() ===
                      "" ? (
                      <StyledAvatar size="default">
                        {startCase(details?.name?.charAt(0) || "N")}
                      </StyledAvatar>
                    ) : (
                      <StyledAvatar
                        src={createdUser(record?.createdByUserId)?.profileurl}
                        size="default"
                      ></StyledAvatar>
                    )}
                  </div>
                  <div className="timeline-item">
                    <span className="timeline-name">
                      {details?.createdByUserName};&nbsp;
                    </span>
                    <span className="timeline-date-time1">
                      created the ticket
                    </span>

                    <span className="timeline-date-time">
                      {moment
                        .utc(details?.insertedAt)
                        .tz(
                          locationList?.find(
                            (location) =>
                              location.location_id ===
                              filteruser && filteruser[0]?.baselocationid
                          )?.usertimezone
                        ) // Convert to Hong Kong time
                        ?.format("Do MMM, YYYY; hh:mm A")}
                    </span>
                  </div>
                </div>
                {details?.actiontimeline?.map((item, index) => (
                  <div className="face-content" key={index}>
                    <div>
                      {!item?.profileUrl || item?.profileUrl.trim() === "" ? (
                        <StyledAvatar size="default">
                          {startCase(item?.insertedby?.charAt(0) || "N")}
                        </StyledAvatar>
                      ) : (
                        <StyledAvatar
                          src={item?.profileUrl}
                          size="default"
                        ></StyledAvatar>
                      )}
                    </div>

                    <div key={item?.key} className="timeline-item">
                      <span className="timeline-name">
                        {item?.insertedby};&nbsp;
                      </span>
                      {item.actionmoveon !== "Commented" &&
                        item.actionmoveon !== "Update the ticket" && (
                          <span className="timeline-action">Moved to </span>
                        )}
                      <span
                        className={`timeline-action 
                                   ${item.actionmoveon === "Verbal Warning" ||
                            item.actionmoveon === "First Warning" ||
                            item.actionmoveon === "Second Warning"
                            ? "verbal-warning first-warning second-warning"
                            : item.actionmoveon ===
                              "Third & Final Warning" ||
                              item.actionmoveon === "Show Cause"
                              ? "third-final-warning show-cause"
                              : item.actionmoveon === "Exoneration"
                                ? "exoneration"
                                : item.actionmoveon === "Suspend"
                                  ? "suspend"
                                  : item.actionmoveon === "Demotion"
                                    ? "demotion"
                                    : item.actionmoveon === "Show Cause"
                                      ? "show-cause"
                                      : item.actionmoveon === "Clearance"
                                        ? "clearance"
                                        : ""
                          }`}
                      >
                        {item?.actionmoveon}{" "}
                        {item.actionmoveon === "Suspend" && (
                          <>

                            <span className="timeline-date-time">
                              {moment(item.suspendfromdate).format(
                                "Do MMM, YYYY; hh:mm A"
                              )}
                            </span>
                          </>
                        )}
                      </span>
                      {item.actionmoveon === "Commented" && (
                        <>
                          {isCommentVisible === index ? (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility(index)}
                            >
                              Close Comment <UpOutlined />
                            </span>
                          ) : (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility(index)}
                            >
                              View Comment <DownOutlined />
                            </span>
                          )}
                        </>
                      )}
                      {item.actionmoveon === "Suspend" && (
                        <div className="for-commented1">
                          <p className="">
                            Duration:
                            <span className="datetext">
                              {" "}
                              {moment(item.suspendfromdate).format(
                                "Do MMM YYYY"
                              )}{" "}
                              -{" "}
                              {moment(item.suspendtodate).format("Do MMM YYYY")}
                            </span>
                          </p>
                          <p>
                            Payment Type:
                            <span className="datetext">
                              {" "}
                              {item.paymenttype ? item.paymenttype : "N/A"}
                            </span>
                          </p>
                        </div>
                      )}
                      {item.actionmoveon !== "Suspend" && <br />}
                      {/* <span className="timeline-date-time">
                                   {item.date};&nbsp;
                                 </span> */}
                      {item.actionmoveon !== "Suspend" && (
                        <span className="timeline-date-time">
                          {moment(item?.insertedAt, "M/D/YYYY, h:mm:ss A")
                            .tz(
                              locationList?.find(
                                (location) =>
                                  location.location_id ===
                                  filteruser[0]?.baselocationid
                              )?.usertimezone
                            )
                            ?.format("Do MMM, YYYY; hh:mm A")}
                        </span>
                      )}

                      {isCommentVisible === index &&
                        item.actionmoveon === "Commented" && (
                          <div>
                            <p className="comment-para">{item?.comment}</p>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />
          {details?.appeals?.length > 0 && (
            <div className="employee-total">
              <Card
                title={
                  <div className="header-container">
                    <span>Appeals ({details?.appeals?.length})</span>
                    <div className="carousel-buttons">
                      <Button
                        icon={<LeftOutlined />}
                        onClick={() => carouselRef.current.prev()}
                      />
                      <Button
                        icon={<RightOutlined />}
                        onClick={() => carouselRef.current.next()}
                      />
                    </div>
                  </div>
                }
                bordered={false}
              >
                <Carousel ref={carouselRef}>
                  {appealChunks?.map((chunk, index) => (
                    <div key={index}>
                      <Row gutter={[16, 16]} justify="center">
                        {chunk?.map((appeal, index) => (
                          <Col
                            xs={24}
                            sm={12}
                            key={appeal.disciplinaryId || index}
                          >
                            <Card bordered className="pt-2">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  color: " #636980",
                                  alignItems: "center",
                                }}
                              >
                                <span>
                                  <Title
                                    level={5}
                                    style={{
                                      display: "inline",
                                      marginRight: 8,
                                    }}
                                  >
                                    Description
                                  </Title>
                                  {/* Show decoded createdAt time next to Description */}
                                  <span
                                    style={{
                                      fontWeight: 400,
                                      fontSize: 14,
                                      color: "#636980",
                                    }}
                                  >
                                    {appeal.createdAt
                                      ? moment
                                        .utc(appeal.createdAt)
                                        .tz(
                                          locationList?.find(
                                            (location) =>
                                              location.location_id === filteruser?.[0]?.baselocationid
                                          )?.usertimezone || "UTC"
                                        )
                                        ?.format("Do MMM, YYYY; hh:mm A")
                                      : ""}

                                  </span>
                                </span>
                              </div>
                              <Text>{appeal.appealText}</Text>
                              <Title level={5} style={{ marginTop: 16 }}>
                                Attachment
                              </Title>

                              {/* Render attachments if available */}
                              {appeal?.appealFiles?.map((item, index) => (
                                <ButtonOutlined
                                  key={item.uid || index}
                                  icon={
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginTop: "-50px",
                                      }}
                                    >
                                      <Fileupload
                                        style={{
                                          position: "relative",
                                          top: "-3px",
                                          fontSize: "16px",
                                          marginLeft: "-10px",
                                          marginRight: "5px",
                                        }}
                                      />
                                    </span>
                                  }
                                  onClick={() => handleOpenModal(item)}
                                >
                                  {item.fileName || "-"}
                                </ButtonOutlined>
                              ))}

                              <Modal
                                title={selectedFileName1 || "No File Name"}
                                open={isModalVisible}
                                onCancel={handleCloseModal}
                                footer={null}
                                centered
                                width={850}
                              >
                                {selectedFileUrl &&
                                  selectedFileName1 &&
                                  (selectedFileName1
                                    .toLowerCase()
                                    .endsWith(".pdf") ? (
                                    <iframe
                                      key={selectedFileUrl}
                                      src={selectedFileUrl}
                                      width="100%"
                                      height="500px"
                                      style={{ border: "none" }}
                                    ></iframe>
                                  ) : (
                                    <img
                                      src={selectedFileUrl}
                                      alt="Preview"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        // maxHeight: "500px",
                                        // display: "block",
                                        objectFit: "contain",
                                      }}
                                    />
                                  ))}
                              </Modal>
                            </Card>
                          </Col>
                        ))}
                        {chunk.length % 2 !== 0 && (
                          <Col xs={24} sm={12}>
                            <Card
                              bordered
                              className="pt-2"
                              style={{ visibility: "hidden" }}
                            >
                              {/* Empty card for alignment */}
                            </Card>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                </Carousel>
              </Card>
            </div>
          )}
          <br />
          {details?.appeals?.length < details?.noofappeal && (
            <div>
              <div className="Mos">
                <div className="editor-label">
                  <div>
                    Appeal ({details?.noofappeal}/{details?.appeals?.length}{" "}
                    left)
                  </div>
                </div>
                <div className="button-container">
                  <Upload
                    key={uploadKey}
                    showUploadList={false}
                    multiple={true}
                    beforeUpload={beforeUpload}
                    customRequest={handleUpload}
                  >
                    <button className="upload-style">
                      <PaperClipOutlined /> &nbsp;Attach File
                    </button>
                  </Upload>

                  <ButtonFilled
                    className={`send-button yy ${loading ? "loading" : ""}`}
                    loading={loading}
                    htmlType="submit"
                    onClick={AppealAction}
                    disabled={!getPlainText(appealDetails).trim()}
                  >
                    <Send1 className="sendstylee" />
                  </ButtonFilled>
                </div>
              </div>
              <div
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault(); // Prevents new line in editor
                    AppealAction(); // Call API function
                  }
                }}
              >
                <EditorConvertToHTML
                  key={editorKey}
                  onChange={(val) => {
                    setAppealDetails(val);
                  }}
                  value={appealDetails}
                />
              </div>
              {/* // content={appeal}
              /> */}
              {/* <GridBuilder
              formStructureJson={ContractForm}
              handleChange={handleFormChange}
              // formSubmit={handleSubmitForm}
              // initialValues={data}
            /> */}
              <div className="d-flex align-items-center gap-2 p-2 file_bg">
                {fileList?.map((item, index) => (
                  <div key={index} className="file_list">
                    {item?.fileName}{" "}
                    <span
                      className="mx-2 fileremove"
                      onClick={() => handleRemove(item.uid)}
                      style={{
                        cursor: "pointer",
                        color: "black",
                        marginLeft: "8px",
                        fontSize: "14px",
                      }}
                    >
                      &times;
                    </span>
                    {/* <span
                    className="mx-2 fileremove"
                    // onClick={() => handleRemove(item.uid)}
                  >
                </span> */}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <StyledModal
          width={470}
          height={140}
          footer={false}
          closable={false}
          open={isDeleteOpen}
          onCancel={handleDeleteCancel}
          style={{ marginTop: "100px" }}
        >
          <p className="delete-modal-text">
            Are you sure you want to delete this disciplinary ticket?
          </p>
          <br />
          <div className="yes-no-button">
            <Button type="secondary" onClick={handleDeleteCancel} className="no-button">
              No
            </Button>
            <Button type="primary" onClick={handleDeleteConfirm} className="yes-button">
              Yes
            </Button>
          </div>
        </StyledModal>
        <StyledModal
          width={190}
          height={70}
          open={isDeletedModalOpen}
          onCancel={() => setIsDeletedModalOpen(false)}
          footer={false}
          closable={false}
          style={{ marginTop: "130px" }}
        >
          <div className="success-modal">
            <Tick />
            <p className="sent-successfully">Deleted</p>
          </div>
        </StyledModal>

        <Modal
          title={selectedFileName || "Attachment Preview"}
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          centered
          width={850}
        >
          {selectedFile &&
            (selectedFileName.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i) ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "500px",
                }}
              >
                <img
                  src={selectedFile}
                  alt="Attachment"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            ) : (
              <iframe
                key={selectedFile}
                src={selectedFile}
                width="100%"
                height="500px"
                style={{ border: "none" }}
              ></iframe>
            ))}
        </Modal>
      </Styleddiv>
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps)(ViewDisciplinary);
